import { useState, useEffect } from "react"
import { Wrapper, Header, LessonWrapper, HeadingColor, RulesWrapper, Frame, Image } from "./GrammarStyle"
import Topics from "./01_topics/Topics"
import { RulesData } from "./02_rules/RulesData"
import { TopicsData } from "./01_topics/TopicsData"
import Exercises from "./03_exercises/Exercises"
import useInstantScroll from "../../hooks/useInstalntScroll"
import ToTheTop from "../../components/04_common/02_tothetop/ToTheTop"
import { useSelector } from "react-redux"
import { grammar } from "../../i18n/06_grammar"



const Grammar = () => {
  const lang = useSelector(state => state.lang.lang)
  const t = grammar[lang]

  const [isGuest, setIsGuest] = useState(false)
  const { jumpToHash } = useInstantScroll();

  const { lessons } = useSelector(state => state.studentLessons)

  const role = useSelector((s) => s.auth?.user?.role); // ✅ add
  const isPrivileged = role === "TEACHER" || role === "ADMIN"; // ✅ add

  // if (!lessons || lessons.length === 0) {
  //   setIsGuest(true)
  // }


  const isLessonUnlocked = (lessonNumber) => {
    // Fallback: if we have no data yet, treat only lesson 1 as unlocked

    // ✅ TEACHER/ADMIN: show everything
    if (isPrivileged) return true;

    if (!lessons || lessons.length === 0) {
      // setIsGuest(true)
      return lessonNumber === 0;
    }


    const lesson = lessons.find((l) => l.order === lessonNumber);
    return !!lesson?.isUnlocked;
  };


  const onTopClick = (lessonNumber) => {

    if (!isLessonUnlocked(lessonNumber)) return;

    jumpToHash(`#lesson-${lessonNumber}`);
  }

  useEffect(() => {
    setIsGuest(!lessons || lessons.length === 0);
  }, [lessons]);

  return (
    <Wrapper>
      <Header>
        {t.header}
      </Header>
      {/* Pass unlock info to topic list */}
      <Topics
        isGuest={isGuest}
        onTopClick={onTopClick}
        isLessonUnlocked={isLessonUnlocked}
      />

      {TopicsData.map((topicVal, topicInd) => {
        const lessonNumber = topicInd + 1;
        // Show grammar content only for unlocked lessons
        if (!isLessonUnlocked(lessonNumber)) {
          return null;
        }
        return (
          <LessonWrapper
            key={topicInd}
            id={`lesson-${lessonNumber}`}
          >
            <HeadingColor>
              Lesson {lessonNumber}
              <div>{topicVal.eng}</div>
              <div>{topicVal.ukr}</div>
            </HeadingColor>
            <RulesWrapper>
              {RulesData.filter((val) => val.lesson === lessonNumber).map((value, index) => (
                <Frame key={index}>
                  <Image src={value.image} />
                </Frame>
              ))}
            </RulesWrapper>

            <Exercises lessonNumber={lessonNumber} />

          </LessonWrapper>
        )
      })}
      <ToTheTop />
    </Wrapper>
  )
}

export default Grammar